<template>
  <div class="cabinet">
    <Header/>
    <template v-if="!user_info.dirty && user_info.data.space_id">
      <InviteAlert v-for="(invite,i) in invitations" :invite="invite" :key="i"/>
    </template>
    <transition name="router-anim">
      <router-view v-if="!current_space.dirty"
                   :class="{blur:current_space.dirty}"/>
    </transition>
  </div>
</template>

<script>
import(/* webpackChunkName: "chunk-vendors-cabinet" */ '@/plugins/cabinetPlugins/index');
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import Header from "@/components/common/Header/Header";
import InviteAlert from "@/components/common/InviteAlert";

export default {
  name: "TheCabinet",
  components: {InviteAlert, Header},
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('cabinet/user', ['user_info']),
    ...mapState('space', ['current_space']),
    ...mapState('cabinet/invitations', ['invitations']),
  },
  methods: {
    ...mapActions('cabinet', ['initCabinet']),
    ...mapActions(['clearCabinetDependencies']),
    ...mapActions('space', ['getCurrentSpaceInfo']),
    ...mapMutations('cabinet/user', ['clearUserInfo']),
    ...mapMutations('cabinet/invitations', ['clearInvites']),
  },
  watch: {
    'user_info.data.space_id': {
      handler: function (newVal) {
        if (!!newVal) {
          this.getCurrentSpaceInfo(newVal);
        }
      }
    },
    'current_space.dirty': {
      async handler(newVal) {
        if (!newVal) {
          this.clearCabinetDependencies();
        }
      }
    },
  },
  async mounted() {
    if (this.user.sub) {
      await this.initCabinet();
    }
  },
  beforeDestroy() {
    this.clearUserInfo();
    this.clearInvites();
  }
}
</script>

<style>
.cabinet {
  min-width: 768px;
}
</style>